import * as React from 'react';
import { selectToken } from '../../util/tokenSelector.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { ListContainer } from './TooltipList.styled.js';
import { TooltipListItem } from './TooltipListItem.js';

var TooltipList = function TooltipList(props) {
  var theme = useThemeContext();
  var padding = selectToken(theme.spacing, '12');
  var hasCaption = props.items.some(function (item) {
    return item.caption;
  });
  var listColumnGap = selectToken(theme.spacing, '24');
  var listRowGap = selectToken(theme.spacing, '8');
  var direction = props.layout === 'row' || hasCaption ? 'column' : 'row';
  var fixedWidth = hasCaption ? '248px' : '320px';
  if (padding) {
    fixedWidth = "calc(".concat(fixedWidth, " - (2 * ").concat(padding, "))");
  }
  return /*#__PURE__*/React.createElement(ListContainer, {
    display: "flex",
    flexDirection: direction,
    flexWrap: "wrap",
    textColor: "base.inverted",
    mt: "12",
    role: "list",
    width: fixedWidth,
    $rowGap: listRowGap,
    $columnGap: direction === 'column' ? undefined : listColumnGap,
    $columnCount: direction === 'column' ? undefined : 2
  }, props.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(TooltipListItem, {
      label: item.label,
      icon: item.icon,
      caption: item.caption
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "".concat(item.label, "-").concat(index)
    });
  }));
};
TooltipList.displayName = 'TooltipList';
TooltipList.defaultProps = {
  layout: 'row'
};

export { TooltipList };
//# sourceMappingURL=TooltipList.js.map
